@let pkg = package();
<div class="cart-summary">
    <div class="ch-header">
        <h4 class="m-0 font-bold" paint="dark">{{pkg ? pkg.short_name + ' plan' : 'Cart Summary'}}</h4>
        <small paint="light">cloudigo.app</small>
    </div>
    <mat-divider class="ch-divider"></mat-divider>
    @if(!is_free() && duration_string()){
        <p paint="warn" class="ch-package font-bold">Paying for {{!retail ? 'first ' : ''}}{{duration_string()}} {{pkg ? ' of ' + pkg.name : ''}}</p>
    } @else {
        <p paint="warn" bold class="ch-package font-bold">Free {{duration_string() ? 'activation for ' + duration_string() : 'Activation'}}</p>
    }

    <div class="plan-receipt">
        @if(use() && retailable()){
            <div class="receipt-row">
                <p class="m-0">Original Price:</p>
                <p class="m-0 font-bold">{{base_price_for_duration() | currency}}</p>
            </div>
            <div class="receipt-row">
                @let diff = discount_amount();
                <p class="m-0">Discount:</p>
                <p class="m-0">{{diff.startsWith('-') ? '+' : '-'}}{{diff.replace('-', '')  | currency}}</p>
            </div>
            <mat-divider style="margin-top: 5px;"></mat-divider>
            <div class="receipt-row">
                <p class="m-0">Total:</p>
                <h2 class="m-0 font-extrabold" paint="warn">{{discounted_price() | currency}}</h2>
            </div>
        } @else {
            <mat-divider style="margin-top: 5px;"></mat-divider>
            <div class="receipt-row">
                <p class="m-0">Total:</p>
                <h2 class="m-0 font-bold">{{base_price() | currency}}</h2>
            </div>
        }
    </div>
</div>